import { SurveyActions } from '@r1-frontend/survey/context/constants/actions';
import { SurveyItem } from '@r1-frontend/survey/context/surveys';

import { IAction } from '@r1-frontend/shared/types/Redux';

const setCommonSurvey = (survey: SurveyItem): IAction<SurveyActions.SetCommonSurvey, { survey: SurveyItem }> => ({
    type: SurveyActions.SetCommonSurvey,
    payload: {
        survey,
    },
});

export default setCommonSurvey;
